import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  standalone: true,
  imports: [
  ]
})
export class ComingSoonComponent extends FieldType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
